import { Select } from 'antd';
import { SelectProps } from 'antd/lib/select';
import { noop } from 'lodash';
import React from 'react';
import { useQuery } from 'react-query';

import {
  getPricingPackList,
  GetPricingPackListParams,
  PricingPackResponse,
} from '../../../services/pricing';

export type PricingInputProps = SelectProps<any> & {
  params: GetPricingPackListParams;
  value?: PricingPackResponse;
  onChange?: (pricing?: PricingPackResponse) => void;
  onClear?: () => void;
  disabled?: boolean;
  allowclear?: boolean;
  onlyOfrid?: boolean;
};

const PricingInput = ({
  params,
  value,
  onChange = noop,
  allowclear,
  onClear,
  onlyOfrid,
  ...otherProps
}: PricingInputProps) => {
  const { data: pricings,isFetching:isLoading } = useQuery(
    [
      'getPricingPackList',params,],
    () =>
      getPricingPackList(
      params).then((res) => res.list || []),
     { enabled: !!params.offerid }
  );

  const handleChange: SelectProps<number>['onChange'] = (value) => {
    if (onlyOfrid) onChange(value as any);
    else onChange(pricings?.find((pricing) => pricing.ofrid === value));
  };

  return (
    <Select
      value={
        typeof value === 'object'
          ? value?.ofrid
          : isNaN(Number(value))
          ? value
          : Number(value)
      }
      loading={isLoading}
      onChange={handleChange}
      allowClear={allowclear}
      onClear={onClear}
      {...otherProps}
    >
      {pricings?.map((pricing) => (
        <Select.Option value={pricing.ofrid} key={pricing.ofrid}>
          {pricing.ofrlabel}
        </Select.Option>
      ))}
    </Select>
  );
};

export default PricingInput;
